export const CommentDayHeader = ({ label }: { label: string }) => (
    <div className="flex items-center gap-1.5 px-4 py-1">
        <small className="text-gray-500 tracking-[1.2px] uppercase whitespace-nowrap">
            {label}
        </small>
        <div className="h-px grow bg-white-100" />
    </div>
)
